module.exports = __webpack_public_path__ + "media/images/apply4_new_logo-f104282a.jpg";